import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8.604 2c1.57 0 2.867.53 3.975.973 1.144.457 2.1.829 3.232.829 1.238 0 2.012-.206 2.444-.38.217-.086.353-.166.423-.212l.053-.04-.01.01-.003.004a1 1 0 0 1 1.697.717v10.81c0 .266-.106.52-.293.708l-.707-.707.706.708-.003.004-.005.004-.01.01a1.24 1.24 0 0 1-.096.085 2.732 2.732 0 0 1-.22.162 4.31 4.31 0 0 1-.789.406c-.694.277-1.723.522-3.187.522-1.57 0-2.867-.53-3.975-.972-1.144-.458-2.1-.83-3.232-.83-1.239 0-2.012.207-2.444.38-.059.023-.113.046-.16.068v5.76a1 1 0 0 1-2 0V3.9c0-.265.105-.52.293-.708L5 3.901a66.013 66.013 0 0 1-.706-.709l.008-.007.01-.01.026-.025.07-.06c.056-.046.128-.101.22-.162.184-.123.443-.267.789-.406C6.111 2.245 7.14 2 8.604 2Z" }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }